import { render, staticRenderFns } from "./AdvancedConfig.vue?vue&type=template&id=0084f036&scoped=true"
import script from "./AdvancedConfig.vue?vue&type=script&lang=js"
export * from "./AdvancedConfig.vue?vue&type=script&lang=js"
import style0 from "./AdvancedConfig.vue?vue&type=style&index=0&id=0084f036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084f036",
  null
  
)

export default component.exports